window.wimmer = window.wimmer || {};

 (function ($) {
    var $ = jQuery = $;

   /**
   * Product Page Helpers
   * -----------------------------------------------------------------------------
   * A collection of custom functions on product pages
   */
    wimmer.ProductUtils = (function () {

        /**
         * converts a product description into a collapsible accordion
         * uses h6-tags as collapsible trigger
         * ands collapsible icons
         * wraps divs with necessary classes around the content
         */
        function convertDescripionToAccordion() {
            
            const accordionMarker = "h6";
            const sectionHeaderIcon = "<span class='collapsible-trigger__icon collapsible-trigger__icon--open' role='presentation'>              <svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-chevron-down' viewBox='0 0 28 16'><path d='M1.57 1.59l12.76 12.77L27.1 1.59' stroke-width='2' stroke='#000' fill='none' fill-rule='evenodd'></path></svg></span>";
            let accordionMarkerList;
            let productDescriptionRaw;
            let productDescriptionRawList;
            
            if(document.getElementsByClassName("product-single__description-full").length>0){
                productDescriptionRawList = document.getElementsByClassName("product-single__description-full");
            }else if(document.getElementsByClassName("product-single__description").length>0){
                productDescriptionRawList = document.getElementsByClassName("product-single__description");
            }

            if(productDescriptionRawList){
                $(productDescriptionRawList).each(function( index, productDescriptionRaw ) {
                    
                    if(productDescriptionRaw){
                        accordionMarkerList = productDescriptionRaw.getElementsByTagName(accordionMarker);
                    
                        for (let i = 0; i < accordionMarkerList.length; i++) {
                            let sectionHeader = $(accordionMarkerList[i]);
                            sectionHeader.addClass("label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders collapsible--auto-height"); 
                            sectionHeader.attr("aria-controls","accordion-"+index+"-"+i);
                            sectionHeader.append(sectionHeaderIcon);
                            
                            let sectionContent = sectionHeader.nextUntil(accordionMarker);
                            sectionContent.wrapAll(`<div class='collapsible-content__inner'>`);
                            sectionContent = sectionContent.parent();
                            sectionContent.wrap(`<div class='collapsible-content collapsible-content--all' id='accordion-${index}-${i}'>`);
                        
                        }
                    }
                });
            }
        }

        /**
         * switches shipping info badge depending on variant selection
         */
        function variantOnChange() {
          $(".variant-input").change(function () {
              const filtervalue = $(this).data("value");
              const constraint_18hundert = $(".shipping-information").data("constraint");
            if (filtervalue.toLowerCase().includes('post')) {
                $(".shipping-information--standard").show();
                $(".shipping-information--mail").hide();
            }
            if (filtervalue.toLowerCase().includes('digital')) {
                $(".shipping-information--standard").hide();
                $(".shipping-information--mail").show();
            }
            if(!!constraint_18hundert){
                if (constraint_18hundert.includes(filtervalue)) {
                    $(".shipping-information--18hundert-constraint").show();
                    $(".shipping-information--18hundert").hide();
                }else{
                    $(".shipping-information--18hundert-constraint").hide();
                    $(".shipping-information--18hundert").show();
                }
            }
          });
        }

        /*
        * there's no 18hundert-Underframe preselected anymore
        * so it needs a divergent initialization and additional change event handling
        * ref: WW-217
        */
        function init18hundertUnderframes(){
            try{
                if(!wimmer.product.isReserved && !wimmer.product.isSoldout){
                    if(!document.querySelector(`#ProductSelect-${sectionId}-option-${optionIndex} input[type=radio]:checked`)){
                        document.getElementById(`AddToCartText-${sectionId}`).innerText = "Bitte Ausführung auswählen";
                        document.getElementById(`AddToCart-${sectionId}`).style = "opacity: 80%";
                        document.getElementById(`AddToCart-${sectionId}`).disabled = true;
                        document.getElementById(`VariantUnderframeLabel-${sectionId}-${optionIndex}`).innerText = "Bitte auswählen";
                    }

                    $('input:radio[name="Untergestell"]').change(function() {
                        document.getElementById(`AddToCartText-${sectionId}`).innerText = "In den Warenkorb";
                        document.getElementById(`AddToCart-${sectionId}`).style = "opacity: 100%";
                        document.getElementById(`AddToCart-${sectionId}`).disabled = false;
                    }); 
                }
            }catch(e) {
            }
        }

        /*
        * add a input validation for reserve forms
        * ref: WW-388
        */
        function reserveFormInputValidation(){
            try{
                //let number_input = $("form input[aria-label='Ihre Kundennummer*']");
                let number_input = $("form input[id^='B2B-Kundennummer']");
                number_input.on("blur",function(){
                    let valid=false;
                    let input = $(this).val();
                    if(input.length == 6 && input.indexOf('K0')==0 && !isNaN(input.substring(2))){
                        valid=true;
                    }
                    console.log("Kundenummer valid: "+ valid);
                    if(!valid){
                        $(this).after(`<div id="require-valid-id" class="needsclick  kl-private-reset-css-Xuajs1" style="width: 100%; position: relative;"><div class="needsclick  kl-private-reset-css-Xuajs1" style="background-color: white; position: absolute; z-index: 1; right: 0px; border-radius: 4px; animation: 0.4s ease 0s 1 normal none running klaviyo-fadein; top: 9px;"><div class="needsclick go407003410 kl-private-reset-css-Xuajs1" style="border-radius: 4px; box-shadow: rgba(0, 0, 0, 0.26) 1px 1px 4px 0px; border: 1px solid rgb(208, 51, 31); background-color: rgb(248, 236, 233);"><span role="alert" id="klaviyo_ariaid_2" class="needsclick  kl-private-reset-css-Xuajs1" style="font-size: 14px; padding: 8px; font-family: Arial, &quot;Helvetica Neue&quot;, Helvetica, sans-serif; color: rgb(208, 51, 31);">Bitte gültige Kundennummer eingeben</span></div></div></div>`);
                        $("form.klaviyo-form").find("button").last().prop('disabled', true);
                    }else{
                        $("form.klaviyo-form").find("button").last().prop('disabled', false);
                    }
                });
                $("form input[aria-labelledby*='Kundennummer']").on("focus",function(){
                    $("#require-valid-id").remove();
                });
            }catch(e) {
            }
        }

        return {
            convertDescripionToAccordion: convertDescripionToAccordion,
            variantOnChange: variantOnChange,
            init18hundertUnderframes: init18hundertUnderframes,
            reserveFormInputValidation, reserveFormInputValidation
        }
    })();
    wimmer.ProductUtils.convertDescripionToAccordion();
    wimmer.ProductUtils.variantOnChange();
    wimmer.ProductUtils.init18hundertUnderframes();
    wimmer.ProductUtils.reserveFormInputValidation();
    
 })(theme.jQuery);  